import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarningTriangleLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.91789 4.5219C10.9767 2.68653 13.6282 2.69375 14.6777 4.5346L21.6376 16.7494C22.6789 18.5781 21.3583 20.851 19.2538 20.851H5.24602C3.13492 20.851 1.81563 18.5664 2.87004 16.7377L9.91789 4.5219ZM13.3739 5.27679C12.8981 4.44293 11.6975 4.44012 11.2177 5.2719L4.16887 17.4867C3.6911 18.3156 4.28975 19.351 5.24602 19.351H19.2538C20.2071 19.351 20.806 18.3206 20.3339 17.4916L13.3739 5.27679ZM12.2597 15.5297C12.6738 15.5298 13.0097 15.8656 13.0097 16.2797V16.3285C13.0095 16.7425 12.6737 17.0785 12.2597 17.0785C11.8456 17.0785 11.5099 16.7426 11.5097 16.3285V16.2797C11.5097 15.8655 11.8455 15.5297 12.2597 15.5297ZM12.2616 9.5219C12.6758 9.522 13.0116 9.85773 13.0116 10.2719V13.2826C13.0116 13.6969 12.6758 14.0326 12.2616 14.0326C11.8473 14.0326 11.5116 13.6969 11.5116 13.2826V10.2719C11.5116 9.85768 11.8473 9.5219 12.2616 9.5219Z",
		fill: "currentColor"
	})
});
export default SvgWarningTriangleLine;
